import { render } from "./QuanLyGiayTo.vue?vue&type=template&id=37d0c848&scoped=true"
import script from "./QuanLyGiayTo.vue?vue&type=script&lang=js"
export * from "./QuanLyGiayTo.vue?vue&type=script&lang=js"

import "./QuanLyGiayTo.vue?vue&type=style&index=0&id=37d0c848&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d0c848"]])

export default __exports__